import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { truncate, eq, join, reject, map } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery, useMutation } from '@apollo/client';
import removeHtml from '../../util/remove_html_markup';
import { SYNC_PAGE_DATA, PAGE_LIST, CLIENT_STATE, SET_CLIENT_STATE, GENERAL_SETTINGS } from '../../graphqls';

export default function PageList({ routeType }) {
  const history = useHistory();
  const [searchKeyword, setSearchKeyword] = useState('');
  const { loading: loadingClientState, data: { sideMenu, selectedPage } = {} } = useQuery(CLIENT_STATE);
  const { loading: loadingPageList, data: { pageList = [] } = {} } = useQuery(PAGE_LIST);
  const { loading: loadingGeneralSettings, data: { generalSettings: { displayLevel = 1, drilldownable = false } = {} } = {} } = useQuery(
    GENERAL_SETTINGS,
    { fetchPolicy: 'network-only' },
  );
  const { loading: loadingSyncPageData, data: { syncPageData = [] } = {} } = useQuery(SYNC_PAGE_DATA);
  const [setState] = useMutation(SET_CLIENT_STATE);
  const onSelect = ({
    target: {
      dataset: { title, id },
    },
  }) => {
    if (routeType === 'main') {
      setState({ variables: { selectedPage: title, sideMenu: '' } });

      if (title === 'HomePage') {
        history.replace('/home/edit');
      } else {
        history.replace(`/plan_node/${id}/edit`);
      }

      if (title === 'HomePage') {
        history.push('/home/edit');
      } else {
        history.push(`/plan_node/${id}/edit`);
      }
    } else {
      setState({ variables: { selectedPage: id } });
    }

    setSearchKeyword('');
    setSearchKeyword('');
  };
  const onClose = () => {
    setState({ variables: { sideMenu: '' } });
    setSearchKeyword('');
  };
  const onSearch = ({ target: { value } }) => setSearchKeyword(value);
  const onClear = () => setSearchKeyword('');
  const availablePages = pageList.filter(({ numberWithLabel, isMeasure, level }) => {
    if (isMeasure) {
      return true;
    }

    // const level = numberWithLabel.split(' ').reverse()[0].split('.').length;
    const specificLevel = { 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, ONE: 1, TWO: 2, THREE: 3, FOUR: 4, FIVE: 5 }[displayLevel];

    if (Number(specificLevel) < level || (Number(specificLevel) === level && !drilldownable)) {
      return false;
    }

    return true;
  });
  const planNodeIds = map(reject(availablePages, 'isMeasure'), 'planNodeId');
  const currentPageList = routeType === 'main' ? availablePages.filter(({ planNodeId }) => planNodeIds.includes(planNodeId)) : syncPageData;
  const pageCount = currentPageList.length;

  if (loadingClientState || loadingPageList || loadingSyncPageData || loadingGeneralSettings || sideMenu !== 'pageListView') {
    return '';
  }

  return (
    <div className="page-list-view-container">
      <div className="page-list-view">
        {routeType === 'main' && <div className="page-list-view-spacer" />}
        <div className="page-list-view-inner">
          <span className="page-size">
            {pageCount}
            <span>Pages</span>
          </span>
          {routeType === 'main' && (
            <button type="button" className="hollow-btn close" onClick={onClose}>
              ×
            </button>
          )}
          <div className="search-page-container input-search">
            <FontAwesomeIcon icon={['fal', 'search']} />
            <input
              type="text"
              value={searchKeyword}
              onChange={onSearch}
              className="form-control"
              placeholder="Search Page Title and Description"
            />
            {!!searchKeyword && (
              <button
                type="button"
                style={{
                  background: 'none',
                  border: 'none',
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  fontWeight: 'bold',
                  fontSize: '2rem',
                  opacity: '0.6',
                }}
                onClick={onClear}
              >
                ×
              </button>
            )}
          </div>
          <div className="page-list-view-section">
            {routeType === 'main' && (
              <div className="page">
                <button type="button" className="page-node home" data-title="HomePage" onClick={onSelect}>
                  <FontAwesomeIcon icon={['fal', 'home']} />
                  Homepage
                </button>
              </div>
            )}
            {currentPageList.map((item, index) => {
              let icon = '';
              let hoverText;
              let node;

              if (routeType === 'main') {
                node = item;
              } else if (item.status === 'added') {
                node = item.syncData;
              } else {
                node = item.currentData;
              }

              const title = item.label || node.title;

              if (item.isMeasure) {
                icon = <FontAwesomeIcon icon={['fal', 'chart-bar']} />;
                hoverText = node.title || node.description;
              } else {
                hoverText = `${item.numberWithLabel} - ${removeHtml(node.description)}`;
              }

              let listItem;

              if (eq(routeType, 'main')) {
                const selectedPageTitle = `${truncate(removeHtml(item.title) || removeHtml(item.description), {
                  separator: ' ',
                  length: 40,
                })}`;

                listItem = (
                  <button
                    type="button"
                    className={`page-node ${!item.enable ? 'disabled-page-node' : ''}`}
                    disabled={!item.enable}
                    data-title={selectedPageTitle}
                    data-id={item.id}
                    onClick={onSelect}
                    title={hoverText}
                  >
                    {icon}
                    {item.label ? <span className="index-nunber">{item.label}:</span> : ''}
                    {selectedPageTitle}
                  </button>
                );
              } else {
                const pageStatusClass = item.status;

                if (item.status === 'added') {
                  node = item.syncData;
                }

                const syncTitle = node.title || node.description.replace(/<[^>]+>/g, '');

                let highLightItem;

                if ((selectedPage === 'HomePage' && index === 0) || item.id === selectedPage) {
                  highLightItem = 'selected';
                }

                listItem = (
                  <button
                    type="button"
                    className={`page-node ${pageStatusClass} ${highLightItem}`}
                    data-title={title}
                    data-id={item.id}
                    onClick={onSelect}
                    title={hoverText}
                  >
                    {item.status === 'removed' ? <FontAwesomeIcon icon={['fal', 'minus-circle']} /> : null}
                    {item.status === 'added' ? <FontAwesomeIcon icon={['fal', 'plus-circle']} /> : null}
                    {icon}
                    {`${title} - ${removeHtml(syncTitle)}`}
                  </button>
                );
              }

              const numberWithLabel = node.numberWithLabel || '';
              const combineString = `${title}${node.title}${numberWithLabel}${node.description}${(title.match(/\b(\w)/g) || []).join('')}${(
                node.description.match(/\b(\w)/g) || []
              ).join('')}`;

              if (
                !searchKeyword ||
                combineString.toLowerCase().replace(/\s/g, '').indexOf(searchKeyword.toLowerCase().replace(/\s/g, '')) >= 0
              ) {
                return (
                  <div className={`page page-${item.level}`} key={join([item.id, index], '-')}>
                    {listItem}
                  </div>
                );
              }

              return '';
            })}
          </div>
        </div>
      </div>
      <div className="overlay" onKeyPress={() => {}} onClick={onClose} role="button" tabIndex={0} />
    </div>
  );
}

PageList.propTypes = {
  routeType: PropTypes.string.isRequired,
};
